// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".packages .mdi-checkbox-blank-circle-outline,.packages .mdi-checkbox-marked-circle-outline,.packages .mdi-information{background-color:#fff;border-radius:50%;z-index:2}.text-complete{word-break:normal}.on-hover{background-color:#a0a0a0}.card-footer-left{bottom:8px;left:17px;position:absolute}.card-footer-right{bottom:-10px;position:absolute;right:-12px}.v-icon.icon-selector{background-color:#fff;position:absolute;right:-12px;top:-10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
